import {Colors} from '@optimaxdev/design-system';
import {CheckoutStyle} from '@primer-io/checkout-web';

import {flags} from 'libs/rollout';

const isFacelift = flags.dCheckoutFacelift.isEnabled();

const commonBaseInputStyles = {
    borderColor: isFacelift ? '#DEDEDE' : '#d8d8d8',
    borderRadius: isFacelift ? '8px' : '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    boxShadow: 'none',
    focus: {
        borderColor: Colors.pictonBlue,
    },
    fontFamily: 'Arial',
    fontSize: isFacelift ? '16px' : '14px',
    height: isFacelift ? '56px' : '48px',
    placeholder: {
        color: Colors.nevada,
    },
};

// style for all Primer hosted inputs
const style: CheckoutStyle = {
    input: {
        base: {
            ...commonBaseInputStyles,
            paddingHorizontal: 18,
        },
        error: {
            background: '#f22a410d',
            borderColor: '#d2431d',
        },
    },
};

export const primerCardNumberOptions = {
    ariaLabel: 'Card number',
    id: 'primer-card-number',
    idFsa: 'fsa-primer-card-number',
    placeholder: '* Card Number',
    style: {
        ...style,
        input: {
            ...style.input,
            base: {
                ...commonBaseInputStyles,
                paddingLeft: isFacelift ? '52px' : '60px',
                paddingRight: '18px',
            },
        },
    },
};

export const primerCardExpiryOptions = {
    ariaLabel: 'Card expiry date',
    id: 'primer-card-expiry',
    idFsa: 'fsa-primer-card-expiry',
    placeholder: '* MM / YY',
    style: {
        ...style,
        input: {
            ...style.input,
            base: {
                ...commonBaseInputStyles,
                paddingLeft: '18px',
                paddingRight: isFacelift ? '12px' : '18px',
            },
        },
    },
};

export const primerCardSecurityCodeOptions = {
    ariaLabel: 'Security code',
    id: 'primer-card-security-code',
    idFsa: 'fsa-primer-card-security-code',
    placeholder: '* CVV',
    style: {
        ...style,
        input: {
            ...style.input,
            base: {
                ...commonBaseInputStyles,
                paddingLeft: isFacelift ? '16px' : '18px',
            },
        },
    },
};

export type PrimerErrorType = {
    'cardNumber-card': string;
    'expiryDate-card': string;
    'cvv-card': string;
};

export const defaultErrorState: PrimerErrorType = {
    'cardNumber-card': '',
    'cvv-card': '',
    'expiryDate-card': '',
};

export enum PrimerInstrumentTypes {
    PAYMENT_CARD = 'PAYMENT_CARD',
}
